import * as React from 'react';
import { IconProps } from '../types';

const IcNoteMulti = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
        <path
      fill="#4384FF"
      d="m21.494 6.445-.094.009L5.954 20.53l.305 1.727a.75.75 0 0 0 .87.61l16-2.821a.75.75 0 0 0 .61-.871l-2.245-12.73Z"
    />
    <path
      fill="#EEF4FF"
      d="M3.276 2.402v16.999a.75.75 0 0 0 .75.75H16.38v-4.459a.187.187 0 0 1 .187-.187h4.46V2.402H3.276Z"
    />
    <path
      fill="#4384FF"
      d="M23.738 19.172 21.494 6.445l-.38-.175-.359.772 2.14 12.13a.75.75 0 0 1-.61.87l-15.62 2.754a.75.75 0 0 0 .464.068l15.999-2.821a.75.75 0 0 0 .61-.871Z"
    />
    <path fill="#EEF4FF" d="M20.181 2.402v13.103h.844V2.402h-.844Z" />
    <path
      fill="#F6D465"
      d="m3.752 5.528 2.276-2.275.487.487L4.24 6.015l-.488-.487Z"
    />
    <path
      fill="#EEF4FF"
      d="m18.383 17.882 2.003-2.003h-4.007v4.007l2.004-2.004Z"
    />
    <path
      fill="#EEF4FF"
      d="m19.917 15.88-2.003 2.002-1.535 1.535v.47l2.004-2.005 2.003-2.003h-.469Z"
    />
    <path
      fill="#F6D465"
      d="m5.713 3.505-2.12-2.123A.88.88 0 0 0 2.35 2.625l2.124 2.12 1.239-1.24Zm-1.96 2.023 2.275-2.275.487.487L4.24 6.015l-.487-.487Z"
    />
    <path
      fill="#F6D465"
      d="m5.713 3.505-2.12-2.123A.88.88 0 0 0 2.35 2.625l2.124 2.12 1.239-1.24Z"
    />
    <path
      fill="#232F3E"
      d="M21.072 3.75V2.214a.234.234 0 0 0-.234-.234H4.315l-.896-.896a1.298 1.298 0 0 0-1.836 1.835l.897.897V19.4a1.175 1.175 0 0 0 1.173 1.173h1.505l.31 1.753a1.173 1.173 0 0 0 1.359.952l16-2.82a1.174 1.174 0 0 0 .952-1.36L21.072 3.75ZM1.914 2.588a.83.83 0 0 1 1.173-1.173l2.09 2.09-1.172 1.173-2.09-2.09Zm4.117.73.42.422L4.24 5.948l-.42-.417L6.03 3.32ZM5.359 20.1H3.653a.706.706 0 0 1-.705-.705V4.283l.726.726-.353.353a.234.234 0 0 0 0 .331l.75.75a.234.234 0 0 0 .332 0l1.107-1.1L6.848 6.68a.235.235 0 1 0 .332-.332L5.843 5.01l1.102-1.104a.235.235 0 0 0 0-.332l-.75-.75a.235.235 0 0 0-.332 0l-.353.352-.726-.727h15.82v13.009H16.19a.234.234 0 0 0-.234.234v4.413L5.359 20.1Zm14.917-4.178-1.927 1.927-1.924 1.925V15.93l3.851-.008Zm2.472 4.07L6.745 22.817a.706.706 0 0 1-.816-.572l-.295-1.672H16.19a.236.236 0 0 0 .166-.068l4.648-4.647a.235.235 0 0 0 .036-.05l.008-.014a.233.233 0 0 0 .02-.054v-.008a.246.246 0 0 0 0-.04v-9.24l2.244 12.727a.705.705 0 0 1-.568.817l.004-.004Z"
    />
    <path
      fill="#232F3E"
      d="M6.706 7.8h12.005a.234.234 0 0 0 0-.47H6.706a.234.234 0 1 0 0 .47ZM4.841 9.664h13.87a.234.234 0 1 0 0-.469H4.84a.234.234 0 1 0 0 .469Zm0 1.867h13.87a.235.235 0 0 0 0-.47H4.84a.234.234 0 1 0 0 .47Zm0 1.863h13.87a.234.234 0 1 0 0-.468H4.84a.234.234 0 1 0 0 .468Zm9.485 1.397H4.841a.234.234 0 1 0 0 .469h9.485a.234.234 0 1 0 0-.469Zm0 1.865H4.841a.234.234 0 1 0 0 .469h9.485a.234.234 0 1 0 0-.47Zm0 1.865H4.841a.234.234 0 1 0 0 .47h9.485a.234.234 0 1 0 0-.47Z"
    />
    <path
      fill="#F6D465"
      d="M22.915 4.875h-.375V4.5a.094.094 0 0 0-.187 0v.375h-.375a.094.094 0 1 0 0 .188h.375v.375a.094.094 0 0 0 .093.093.094.094 0 0 0 .094-.093v-.375h.375a.094.094 0 0 0 0-.188Z"
    />
    <path
      fill="#4384FF"
      d="M22.353 1.922h-.375v-.375a.094.094 0 0 0-.188 0v.375h-.375a.094.094 0 1 0 0 .187h.375v.375a.094.094 0 0 0 .094.094.094.094 0 0 0 .094-.094V2.11h.375a.094.094 0 0 0 0-.187Zm.272 6.59a.563.563 0 1 1 0-1.126.563.563 0 0 1 0 1.126Zm0-.938a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75Z"
    />
  </svg>
);

export default IcNoteMulti;
